<template>
  <svg id="Group_31782" data-name="Group 31782" xmlns="http://www.w3.org/2000/svg" width="21" height="5" viewBox="0 0 21 5">
    <circle id="Ellipse_35" data-name="Ellipse 35" cx="2.5" cy="2.5" r="2.5" />
    <circle id="Ellipse_36" data-name="Ellipse 36" cx="2.5" cy="2.5" r="2.5" transform="translate(8)" />
    <circle id="Ellipse_37" data-name="Ellipse 37" cx="2.5" cy="2.5" r="2.5" transform="translate(16)" />
  </svg>
</template>
